import request, { ResponsePageableData } from '@/libs/request'

/** 用户列表 */
export const getUserList = (data?) => request<ResponsePageableData>({ url: '/adminapi/User/getUserList', data })
